import { create } from "zustand";

interface CommandMenuStore {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCommandMenuStore = create<CommandMenuStore>(set => ({
  isOpen: false,
  setOpen: open => set({ isOpen: open }),
  toggle: () => set(state => ({ isOpen: !state.isOpen })),
}));
